import { render, staticRenderFns } from "./sign_commission_money.vue?vue&type=template&id=4b6518af&"
import script from "./sign_commission_money.vue?vue&type=script&lang=js&"
export * from "./sign_commission_money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports